/**
 * @generated SignedSource<<d88689a34244d08bfd9a40d6a9811316>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteCommentInput = {
  id: string;
  taskId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteCommentMutation$variables = {
  input: DeleteCommentInput;
};
export type deleteCommentMutation$data = {
  readonly deleteComment: {
    readonly deletedCommentId: string | null;
  } | null;
};
export type deleteCommentMutation = {
  variables: deleteCommentMutation$variables;
  response: deleteCommentMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCommentPayload",
    "kind": "LinkedField",
    "name": "deleteComment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedCommentId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bf1c12022686e1544e840136e2b00a45",
    "id": null,
    "metadata": {},
    "name": "deleteCommentMutation",
    "operationKind": "mutation",
    "text": "mutation deleteCommentMutation(\n  $input: DeleteCommentInput!\n) {\n  deleteComment(input: $input) {\n    deletedCommentId\n  }\n}\n"
  }
};
})();

(node as any).hash = "954595877ae995762720af7b33c3204a";

export default node;
